"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _GiftResearchFlow = require("../../../types/GiftResearchFlow.types");

var _RecipientExperienceFlowLink = require("../../../Shared/components/RecipientExperienceFlowLink");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    settings: {
      marginTop: spacing(2),
      border: "1px solid ".concat(palette.divider),
      padding: spacing(2),
      borderRadius: 5
    },
    owner: {
      marginTop: spacing(2)
    },
    ownerAvatar: {
      width: 18,
      height: 18,
      marginLeft: spacing(1),
      marginRight: spacing(1)
    }
  };
});

var CampaignDetails = function CampaignDetails(_ref2) {
  var campaign = _ref2.campaign,
      apiHost = _ref2.apiHost;
  var classes = useStyles();
  var settingsArray = (0, _react.useMemo)(function () {
    var visibleSettings = [];

    if (campaign.settings.enterpriseBudget.min) {
      visibleSettings.push({
        label: 'Gift budget',
        value: "".concat(campaign.settings.currency.sign).concat(campaign.settings.enterpriseBudget.min, " - ").concat(campaign.settings.currency.sign).concat(campaign.settings.enterpriseBudget.max)
      });
    }

    visibleSettings.push({
      label: 'Choosing options',
      value: _GiftResearchFlow.giftResearchFlowTypeNames[campaign.researchFlow]
    });

    if (campaign.settings.messageSubject) {
      visibleSettings.push({
        label: 'Message',
        value: campaign.settings.messageSubject
      });
    }

    if (campaign.settings.from) {
      visibleSettings.push({
        label: 'Send as',
        value: campaign.settings.from.fullName
      });
    }

    return visibleSettings;
  }, [campaign]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    className: classes.settings
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Inactive"
  }, "This campaign has ", settingsArray.length, " default settings \u2014", settingsArray.map(function (setting) {
    return /*#__PURE__*/_react.default.createElement("span", {
      key: setting.label
    }, ' ', setting.label, ": ", /*#__PURE__*/_react.default.createElement("span", {
      className: "Label-Table-Left-Active"
    }, setting.value, ";"));
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    className: classes.owner
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Inactive"
  }, "Owned by:"), /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: classes.ownerAvatar,
    src: campaign.owner.avatar
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Static"
  }, campaign.owner.fullName)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    className: classes.owner
  }, /*#__PURE__*/_react.default.createElement(_RecipientExperienceFlowLink.RecipientExperienceFlowLink, {
    apiHost: apiHost,
    campaignId: campaign.id,
    endIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "external-link",
      fontSize: 1
    })
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(CampaignDetails);

exports.default = _default;